// extracted by mini-css-extract-plugin
export default {"skeleton":"_uAbtR","skeletonButton":"EGAWi4","skeletonGroup":"tLr25k","infoIcon":"elWjQA","disabledText":"zWtPtU","highlightPrice":"ZOE3KR","mobileSkeletonGroup":"Y1qYgK"};